const POSTER_FLOOR_ACTIVE_LABEL_ID = 'poster-floor-active-label-id'

export {
    POSTER_FLOOR_ACTIVE_LABEL_ID
}